const allSkills = [
    { id: "01", skillType: 'web', skill: "React", expertLevel: 90 },
    { id: "02", skillType: 'web', skill: "Node.JS", expertLevel: 70 },
    { id: "03", skillType: 'web', skill: "Express.JS", expertLevel: 70 },
    { id: "04", skillType: 'web', skill: "MongoDB", expertLevel: 85},
    { id: "05", skillType: 'web', skill: "Mongoose", expertLevel:  85},
    { id: "06", skillType: 'web', skill: "Redux", expertLevel: 80},
    { id: "07", skillType: 'web', skill: "Bootstrap", expertLevel: 95},
    { id: "08", skillType: 'web', skill: "HTML", expertLevel:  95 },
    { id: "09", skillType: 'web', skill: "CSS", expertLevel:  95},
    { id: "10", skillType: 'web', skill: "Sass", expertLevel:  95},

    { id: "11", skillType: 'programming', skill: "JavaScript", expertLevel: 90 },
    { id: "12", skillType: 'programming', skill: "C", expertLevel: 80 },
    { id: "13", skillType: 'programming', skill: "Java", expertLevel: 60 },

    { id: "14", skillType: 'tools', skill: "Git", expertLevel: 95 },
    { id: "15", skillType: 'tools', skill: "VSCode", expertLevel: 95 },
    { id: "16", skillType: 'tools', skill: "Firebase", expertLevel: 90 },
    { id: "17", skillType: 'tools', skill: "Heroku", expertLevel: 90 },
    { id: "18", skillType: 'tools', skill: "Dev Tool", expertLevel: 90 },
    { id: "19", skillType: 'tools', skill: "Npm", expertLevel: 90 },
    { id: "20", skillType: 'tools', skill: "Web Pack", expertLevel: 90 },
    { id: "21", skillType: 'tools', skill: "Netlify", expertLevel: 90 },
];

export default allSkills;